export type TypographyTone = "light" | "dark";

export type TypographySampleKind =
  | "hugeTitle"
  | "subtitle"
  | "itemTitle"
  | "body"
  | "tinyLabel";

export type TypographySample = {
  id: string;
  kind: TypographySampleKind;
  note: string;
  markdownTag: string;
};

export type TypographyModeSpec = {
  tone: TypographyTone;
  title: string;
  samples: TypographySample[];
};

export const typographyModeSpecs: TypographyModeSpec[] = [
  {
    tone: "light",
    title: "Light 模式文字 (白底黑字)",
    samples: [
      {
        id: "A.1.1.L",
        kind: "hugeTitle",
        note: "全站最大的字号，全大写且行高紧凑。",
        markdownTag: "#",
      },
      {
        id: "A.1.2.L",
        kind: "subtitle",
        note: "包裹大组件组合的顶层标题。",
        markdownTag: "##",
      },
      {
        id: "A.1.3.L",
        kind: "itemTitle",
        note: "卡片内部或正文上方的小标题，字号相对收敛。",
        markdownTag: "###",
      },
      {
        id: "A.1.4.L",
        kind: "body",
        note: "主要阐述文本，使用 Bold，灰色调辅助说明为 text-zinc-700。",
        markdownTag: "p",
      },
      {
        id: "A.1.5.L",
        kind: "tinyLabel",
        note: "用于标签，白底模式下黑底白字。",
        markdownTag: "small",
      },
    ],
  },
  {
    tone: "dark",
    title: "Dark 模式文字 (黑底白字)",
    samples: [
      {
        id: "A.1.1.D",
        kind: "hugeTitle",
        note: "全站最大的字号，全大写且行高紧凑。",
        markdownTag: "#",
      },
      {
        id: "A.1.2.D",
        kind: "subtitle",
        note: "包裹大组件组合的顶层标题。",
        markdownTag: "##",
      },
      {
        id: "A.1.3.D",
        kind: "itemTitle",
        note: "卡片内容小标题，黑底模式下的标准色标默认使用纯白。",
        markdownTag: "###",
      },
      {
        id: "A.1.4.D",
        kind: "body",
        note: "主要阐述文本，使用 Bold，深底色下的辅助说明为 text-zinc-400。",
        markdownTag: "p",
      },
      {
        id: "A.1.5.D",
        kind: "tinyLabel",
        note: "用于标签，黑底模式下白底黑字。",
        markdownTag: "small",
      },
    ],
  },
];
